import axiosInstances from "./axios"
import Leaflet from "./leaflet"

const AppConfig = {
  axiosInstances,
  Leaflet,
}

export default AppConfig
